import AdvertiserDetailPage from "./AdvertiserDetailPage";

export default AdvertiserDetailPage;
